import { memo, ReactNode, useMemo } from "react"

import './index.scss'
import { useTranslation } from "react-i18next"

type Panel = {
  children: ReactNode
  type: 'active' | 'inactive' | 'none'
}

const Panel = memo(({ children, type }: Panel) => {
  const { t } = useTranslation()

  const classes = useMemo(() => {
    const classArr = ['Panel']
    if (type === 'active') classArr.push('active')
    if (type === 'inactive') classArr.push('inactive')
    return classArr
  }, [type])

  return (
    <div className={classes.join(' ')} >
      {type !== 'none' && (
        <div className="Panel__header">
          {type === 'active' ? t('Active panels') : t('Inactive panels')}
        </div>
      )}
      {children}
    </div>
  )
})

export default Panel
